import React, { useEffect, useState } from "react";
import { PiXFill } from "react-icons/pi";
import { putApi } from "../../../../services/api/globalApi";
import { successMessage } from "../../../../utils/toastify-message/ToastifyMessage";
import { useSelector } from "react-redux";
import { utilsState } from "../../../../sotre/redux/features/utilsSlice";

const { forwardRef, useRef, useImperativeHandle } = React;

const VendorStatusModal = forwardRef(({ data, reGetData, isGet }, ref) => {
  const [showModal, setShowModal] = useState(false);
  const [status, setStatus] = useState(null);

  useImperativeHandle(ref, () => ({
    showModal() {
      setShowModal(!showModal);
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
    afterSubmit() {},
  }));

  const { utils } = useSelector(utilsState);

  const formHandler = async () => {
    const path = `admin/vendorStores/${data?._id}`;
    const body = { status };
    try {
      await putApi({ path, body });
      successMessage("وضعیت غرفه با موفقیت تغییر کرد");
      if (isGet) {
        reGetData({});
      }
      setShowModal(false);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (data?.status) {
      setStatus(data.status);
    }
  }, [data]);

  return (
    <>
      <div
        className={`fixed top-0 right-0 w-full h-full bg-black/40 transition-all z-30  ${
          !showModal && "hidden"
        }`}
      ></div>
      <div
        className={`w-[340px] sm:w-[800px] py-4 max-h-[360px] overflow-y-scroll bg-white mt-4 shadow-md z-40 rounded-3xl p-4 transition-all fixed top-0 right-[50%] mr-[-170px] sm:mr-[-400px] opacity-0 invisible ${
          showModal && "!mt-20 !opacity-100 !visible"
        }`}
      >
        <div className="w-full px-6 flex items-center justify-between py-4 border-b-2">
          <h4>تغییر وضعیت غرفه {data?.name}</h4>
          <PiXFill
            onClick={() => setShowModal(false)}
            size={30}
            className="text-red-400 transition-all hover:text-red-600 cursor-pointer"
          />
        </div>
        <div className="bg-white/50 backdrop-blur-sm rounded-2xl p-6 py-3">
          <div>
            <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
              تغیر وضعیت غرفه
            </label>
            <select
              value={status}
              onChange={(e) => setStatus(e.target.value)}
              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
            >
              {utils
                ? utils?.VENDOR_STATUS_VALUES?.map((item) => {
                    return <option value={item.value}>{item.name}</option>;
                  })
                : null}
            </select>
          </div>
        </div>
        <div className="flex gap-2 justify-end w-full">
          <button
            type="button"
            className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 me-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800"
            onClick={() => setShowModal(false)}
          >
            بازگشت
          </button>
          <button
            onClick={() => formHandler(true)}
            type="button"
            className="text-white bg-green-700 hover:bg-green-800 focus:ring-4 focus:ring-green-300 font-medium rounded-lg text-sm px-5 py-2.5 me-2 mb-2 dark:bg-green-600 dark:hover:bg-green-700 focus:outline-none dark:focus:ring-green-800"
          >
            تغییر وضعیت
          </button>
        </div>
      </div>
    </>
  );
});
export default VendorStatusModal;
